/**
 * @file The root container of every page: a column at least the shell's height
 * and exactly its parent's width. Consumers: every page under `react/src/pages`.
 * It never widens past its parent, so the document never scrolls sideways
 * because of it; wide children scroll inside their own container. `FormPage` is
 * the one opt-in to `width: 'max-content'`, because ArTable's sticky header and
 * first column ride document scroll.
 */
import React, { FC, ReactNode } from 'react';
import { LayoutProps, theme } from 'antd';

interface FlexPageProps extends LayoutProps {
    children: ReactNode;
    style?: React.CSSProperties;
}

const FlexPage: FC<FlexPageProps> = ({ children, style, ...props }) => {
    const { token } = theme.useToken();
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: token.colorBgLayout,
                minHeight: '100%',
                width: '100%',
                minWidth: '100%',
                boxSizing: 'border-box',
                ...style,
            }}
            id='flex-page'
            {...props}
        >
            {children}
        </div>
    );
};
export default FlexPage;